import type { Vec2 } from "@core/types";

/** Спецификация одного collectible в уровне. */
export interface CollectibleSpec {
  readonly id: string;
  readonly position: Vec2;
}

/** Полная конфигурация уровня. */
export interface LevelConfig {
  readonly id: string;
  readonly playerStart: Vec2;
  readonly seeds: readonly CollectibleSpec[];
  readonly sand: readonly CollectibleSpec[];
  readonly flowers: readonly CollectibleSpec[];
  readonly glowflies: readonly CollectibleSpec[];
}

/** Данные первого уровня — из legacy/game.js. */
export const LEVEL_MOONLEAF: LevelConfig = {
  id: "moonleaf",
  playerStart: { x: 50, y: 70 },
  seeds: [
    { id: "seed-1", position: { x: 24, y: 30 } },
    { id: "seed-2", position: { x: 76, y: 31 } },
    { id: "seed-3", position: { x: 37, y: 51 } },
    { id: "seed-4", position: { x: 66, y: 68 } },
    { id: "seed-5", position: { x: 20, y: 84 } },
  ],
  sand: [
    { id: "sand-1", position: { x: 35, y: 76 } },
    { id: "sand-2", position: { x: 39, y: 72 } },
    { id: "sand-3", position: { x: 43, y: 68 } },
    { id: "sand-4", position: { x: 57, y: 39 } },
    { id: "sand-5", position: { x: 61, y: 42 } },
    { id: "sand-6", position: { x: 65, y: 45 } },
    { id: "sand-7", position: { x: 81, y: 61 } },
  ],
  flowers: [
    { id: "flower-1", position: { x: 14, y: 42 } },
    { id: "flower-2", position: { x: 85, y: 43 } },
    { id: "flower-3", position: { x: 58, y: 82 } },
  ],
  glowflies: [
    { id: "glowfly-1", position: { x: 30, y: 40 } },
    { id: "glowfly-2", position: { x: 72, y: 56 } },
    { id: "glowfly-3", position: { x: 46, y: 24 } },
    { id: "glowfly-4", position: { x: 50, y: 78 } },
  ],
};
